import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 }
  }

  connect() {
    this.autoDismiss()
  }

  close() {
    this.dismiss()
  }

  autoDismiss() {
    if (this.timeoutValue > 0) {
      this.timeoutId = setTimeout(() => {
        this.dismiss()
      }, this.timeoutValue)
    }
  }

  dismiss() {
    // Add hiding class to trigger exit animation
    this.element.classList.add("flash-hiding")

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300) // Match the animation duration in CSS
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }
}
